export default __webpack_public_path__ + "static/media/Business.72a21832.png";